'use strict';

angular.module('mean.projects').directive('colorItem', function() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModelController) {
      ngModelController.$parsers.push(function(data) {
        //convert data from view format to model format
        console.log(data);
        return data; //converted
      });

      ngModelController.$formatters.push(function(data) {
        //convert data from model format to view format
        console.log(data)
        return data; //converted
      });
    }
  }
});


// app.directive("matrix", function($compile){
//  return{
//  scope:{
//    ngModel:'='
//  },
//  restrict:"E",
//  link:function(scope, element, attributes){
//    var render = function(){
//     var template="";
//     scope.ngModel.forEach(function(row, r){
//       template+="<p>";
//       console.log(scope.ngModel[r]);
//       row.forEach(function(column, c){
//         template+='<span><input style="width: 20px; text-align: center;" ng-model="ngModel['+r+']['+c+']"></span>';
//       });
//       template+="</p>";
//     });
//     element.html(template);
//     $compile(element.contents())(scope);
//   }
//   render();
//   scope.$watch('ngModel', render, true);
//  }
// }
// });


// WEBPACK FOOTER //
// ./packages/custom/projects/public/directives/color-item.js